import { Maximize, Minimize } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

export interface KioskToggleProps {
  isFullscreen: boolean;
  onToggle: () => void;
  className?: string;
}

/**
 * Icon button that enters or exits kiosk (fullscreen) mode.
 * Renders a Maximize icon when not fullscreen, Minimize when fullscreen.
 */
export function KioskToggle({ isFullscreen, onToggle, className }: KioskToggleProps) {
  return (
    <Button
      data-slot="kiosk-toggle"
      variant="ghost"
      size="icon"
      aria-label={isFullscreen ? "Exit kiosk mode" : "Enter kiosk mode"}
      onClick={onToggle}
      className={cn(className)}
    >
      {isFullscreen ? <Minimize aria-hidden /> : <Maximize aria-hidden />}
    </Button>
  );
}
